import { Avatar, Card, CardContent, Typography, Link } from "@mui/joy";
import { Link as RouterLink } from "react-router-dom";

export interface BrandMiniCardProps {
  name: string;
  slug: string;
  kind: "BRAND" | "AGENCY";
  picture?: string | null;
  description?: string | null;
  createdAt?: string | null;
  contacts?: { key: string; value: string }[];
}

export default function BrandMiniCard({
  name,
  slug,
  contacts,
  picture,
  description,
  kind,
}: BrandMiniCardProps) {
  return (
    <Card
      variant="outlined"
      orientation="horizontal"
      sx={{
        background: "hsl(0deg 0% 31.06% / 35%)",
        "&:hover": {
          boxShadow: "md",
          borderColor: "neutral.outlinedHoverBorder",
          background: "hsl(0deg 0% 51.06% / 35%)",
        },
      }}
    >
      <Avatar
        size="sm"
        sx={{
          height: 36,
          // width: "100%",
          minWidth: 36,
          width: 36,
          borderRadius: 4,
        }}
        src={picture ?? "/images/qcsku_dark.jpg"}
      />
      <CardContent>
        <Typography level="title-lg" id="card-description">
          {name}
        </Typography>
        <Typography
          level="body-sm"
          aria-describedby="card-description"
          sx={{ mb: 1 }}
        >
          <Link
            component={RouterLink}
            color="neutral"
            to={"/network/" + slug}
            overlay
            underline="none"
            sx={{ color: "text.tertiary" }}
          >
            {description}
          </Link>
        </Typography>
      </CardContent>
    </Card>

    // <Card
    //   sx={{ backgroundColor: "hsl(0deg 0% 31.06% / 35%);", gap: 0, padding: 0 }}
    // >
    //   {/* <Link
    //     sx={{ m: 0.5 }}
    //     underline="none"
    //     component={RouterLink}
    //     to={`/${slug}`}
    //   > */}
    //   <Stack direction="row" sx={{ alignItems: "center", m: 0.5 }}>
    //     <Avatar
    //       size="sm"
    //       sx={{
    //         height: 32,
    //         minWidth: 32,
    //         width: 32,
    //         borderRadius: 4,
    //       }}
    //       src={
    //         picture
    //           ? picture
    //           : mode === "light"
    //           ? "/images/qcsku_light.jpg"
    //           : "/images/qcsku_dark.jpg"
    //       }
    //     />
    //     <Typography
    //       noWrap
    //       sx={{
    //         display: "flex",
    //         textAlign: "left",
    //         ml: 1,
    //         fontWeight: "lg",
    //         flex: 1,
    //       }}
    //     >
    //       {name}
    //     </Typography>
    //     <Chip
    //       variant="soft"
    //       sx={{
    //         color: "var(--joy-palette-neutral-500)",
    //         borderRadius: 4,
    //         fontSize: 10,
    //       }}
    //     >
    //       {kind}
    //     </Chip>
    //     <IconButton
    //       onClick={() => {
    //         navigate("/network/" + slug);
    //       }}
    //       variant="outlined"
    //       size="sm"
    //     >
    //       <OpenInFullIcon />
    //     </IconButton>
    //     {/* </Link> */}
    //   </Stack>

    //   <CardContent
    //     sx={{
    //       margin: "1px",
    //       borderRadius: 5,
    //       border: "1px solid black",
    //       bgcolor: "background.surface",
    //       gap: 0,
    //       p: 0.5,
    //     }}
    //   >
    //     <Typography level="body-sm">{description}</Typography>
    //     <Stack gap={0.5}>
    //       {contacts?.slice(0, 3).map((method, index) => (
    //         <Chip
    //           key={index}
    //           variant="soft"
    //           sx={{ borderRadius: 4 }}
    //           startDecorator={
    //             iconMap[method.key] ?? <Message style={{ fontSize: 14 }} />
    //           }
    //         >
    //           {method.value}
    //         </Chip>
    //       ))}
    //     </Stack>
    //   </CardContent>
    // </Card>
  );
}
